import React from "react"
import * as styles from "./FooterMenu.module.css"
import { Link } from "gatsby"
import AboutSVG from "../../../../images/footer/about.inline.svg"
import ContactSVG from "../../../../images/footer/contact.inline.svg"
import BlogSVG from "../../../../images/footer/blog.inline.svg"
import PricingSVG from "../../../../images/footer/pricing.inline.svg"
import FAQSVG from "../../../../images/footer/FAQ.inline.svg"
import PrivacyPolicySVG from "../../../../images/footer/privacy-policy.inline.svg"
import TermsConditionsSVG from "../../../../images/footer/terms-and-conditions.inline.svg"
import FaceBookSVG from "../../../../images/facebook.inline.svg"
import LinkedinSVG from "../../../../images/linkedin.inline.svg"
import YoutubeSVG from "../../../../images/youtube.inline.svg"

const FooterMenu = () => {
  return (
    <div>
      <ul className={styles.container}>
        <li>
          <AboutSVG />
          <Link to="/about">About</Link>
        </li>
        <li>
          <ContactSVG />
          <Link to="/contact">Contact</Link>
        </li>
        <li>
          <BlogSVG />
          <Link to="/blog">Blog</Link>
        </li>
        <li>
          <PricingSVG />
          <Link to="pricing">Pricing</Link>
        </li>
        <li>
          <FAQSVG />
          <Link to="/faq">FAQ</Link>
        </li>
        <li>
          <PrivacyPolicySVG />
          <Link to="/privacy-policy">Privacy Policy</Link>
        </li>
        <li>
          <TermsConditionsSVG />
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
        </li>
      </ul>

      <div className={styles.bottomContent}>
        <button className={styles.bookDemoFooter}>Book a Demo</button>
        <div className={styles.icons}>
          <Link
            to="https://www.linkedin.com/company/pressnxpress"
            target="_blank"
            rel="noreferrer"
            aria-label="Linkedin"
          >
            <LinkedinSVG />
          </Link>
          <Link to="https://www.facebook.com/pressnxpress">
            <FaceBookSVG />
          </Link>
          <Link to="https://www.youtube.com/@pressnxpress">
            <YoutubeSVG />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default FooterMenu
